module.exports = __webpack_public_path__ + "4d7d1288.png";